namespace TabAurous.HR {
    export interface PayrollEmployeeDetailsRow {
        EmployeeDetailId?: number;
        EmployeeId?: number;
        ComponentId?: number;
        Code?: string;
        Type?: Common.SalaryComponentType;
        Percentage?: number;
        Amount?: number;
    }

    export namespace PayrollEmployeeDetailsRow {
        export const idProperty = 'EmployeeDetailId';
        export const localTextPrefix = 'HR.PayrollEmployeeDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            EmployeeDetailId = "EmployeeDetailId",
            EmployeeId = "EmployeeId",
            ComponentId = "ComponentId",
            Code = "Code",
            Type = "Type",
            Percentage = "Percentage",
            Amount = "Amount"
        }
    }
}
